import React from 'react';

import pic23 from '../../assets/pic23.png'
import './subpagecta.css'

const SubpageCTA = (props) => {
    return ( 
        <button className={props.style1} type="button"          onClick={props.onClick}   >
                <img src={props.img} alt='icon' className='iconnnn-addd-cta'></img>
                <h2 className={props.style2}>{props.title}</h2>
        </button>
     );
}
 
export default SubpageCTA;